import PosterForColumn from '../posterForColumn/posterForColumn.js';
import PosterForHistory from '../posterForHistory/posterForHistory.js';
import PosterForHome from '../posterForHome/posterForHome.js';
import PosterForOtherPage from '../posterForOtherPage/posterForOtherPage.js';
import PosterForRec from '../posterForRec/posterForRec.js';
import HistoryBtn from '../historyBtn/historyBtn.js';
import MoreBtn from '../moreBtn/moreBtn.js';

export default function pictureBox(props) {
  const {
    posterBox: { posterArr: { posterType } },
  } = props;

  // 1:轮播图(精选页)850*364 2：栏目408*230 3：推荐栏260*364 4：观看历史408*230 5:轮播图(其他页)556*314
  switch (posterType) {
    case 1:
      return <PosterForHome {...props}/>;
    case 2:
      return <PosterForColumn {...props}/>;
    case 3:
      return <PosterForRec {...props}/>;
    case 4:
      return <PosterForHistory {...props}/>;
    case 5:
      return <PosterForOtherPage {...props}/>;
    case 6:
      return <HistoryBtn {...props}/>;
    default:
      return <MoreBtn {...props}></MoreBtn>;
  }
}
